/**
 * Rascunho do cadastro (/register) salvo no navegador, para o usuário poder
 * fechar a tela e continuar depois. Senhas nunca são persistidas.
 */

const STORAGE_KEY = 'registerDraft'

export interface RegisterDraftValues {
  type: string
  name: string
  owner_name: string
  owner_email: string
  owner_phone: string
  uf_id: string
  city_id: string
  address: {
    postal_code: string
    street: string
    number: string
    complement?: string
    neighborhood: string
    city: string
    state: string
  }
}

export interface RegisterDraft {
  values: RegisterDraftValues
  step: number
  savedAt: string
}

export function hasRegisterDraftData(values: RegisterDraftValues): boolean {
  const { address, ...rest } = values
  return [...Object.values(rest), ...Object.values(address)].some(
    (value) => typeof value === 'string' && value.trim() !== ''
  )
}

export function getRegisterDraft(): RegisterDraft | null {
  if (typeof window === 'undefined') return null

  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const draft = JSON.parse(raw) as RegisterDraft
    if (!draft?.values || !hasRegisterDraftData(draft.values)) return null
    return draft
  } catch {
    localStorage.removeItem(STORAGE_KEY)
    return null
  }
}

export function saveRegisterDraft(values: RegisterDraftValues, step: number): void {
  if (typeof window === 'undefined') return

  try {
    if (!hasRegisterDraftData(values)) {
      localStorage.removeItem(STORAGE_KEY)
      return
    }
    const draft: RegisterDraft = { values, step, savedAt: new Date().toISOString() }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(draft))
  } catch {
    // Storage indisponível (modo privado, cota cheia): segue sem rascunho.
  }
}

export function removeRegisterDraft(): void {
  if (typeof window === 'undefined') return

  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore
  }
}
